/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */

import { Button } from '@mui/material';
import { LuceneQueryUtils } from '@vamstar/fox-api-common/esm/utils';
import React, { useEffect, useState } from 'react';

import { DSL_OPERATOR_WITH_SPACING } from '../constants';
import { ElasticDslEntitlementContext } from './ElasticDslEntitlementContext';
import { ElasticDslEntitlementQueryForm } from './ElasticDslEntitlementQueryForm';

interface IElasticDslEntitlementProps {
  onAddingEntitlement: (entitlement: string | undefined) => void;
  existingDslEntitlement: string | undefined;
}

export const ElasticDslEntitlementForm = (props: IElasticDslEntitlementProps) => {
  const { onAddingEntitlement, existingDslEntitlement } = props;
  const [entitlement, setEntitlement] = useState<string | undefined>(existingDslEntitlement);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!existingDslEntitlement) {
      setEntitlement(undefined);
    }
    return () => {};
  }, [open]);

  return (
    <>
      <Button variant="contained" onClick={() => setOpen(!open)}>
        Add/edit elastic DSL
      </Button>
      <ElasticDslEntitlementContext.Provider
        value={{
          query: entitlement,
          setQuery: (updatedQuery) => {
            setEntitlement(updatedQuery);
          },
          addOperator: (operator) => {
            let updatedValue = `${entitlement || ''}${operator.toString()}`;
            if (DSL_OPERATOR_WITH_SPACING.includes(operator)) {
              updatedValue = `${entitlement} ${operator.toString()} `;
            }
            setEntitlement(updatedValue);
          },
          clearValue: () => setEntitlement(undefined),
          onCancel: () => {
            setEntitlement(undefined);
            setOpen(false);
          },
          onAdd: () => {
            if (LuceneQueryUtils.isLuceneQuery(entitlement)) {
              onAddingEntitlement(entitlement);
            }
          },
        }}
      >
        <ElasticDslEntitlementQueryForm open={open} onClose={() => setOpen(false)} />
      </ElasticDslEntitlementContext.Provider>
    </>
  );
};
